import { Injectable, NgZone } from '@angular/core';
// import { User } from '../services/user';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { getToken } from 'firebase/app-check';
import { HttpClient } from '@angular/common/http';
import { PushTokenService } from './push-token.service';
import { NativeTwilioVoiceService } from './native-twilio-voice.service';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private loginSuccessSubject = new Subject<void>();
    loginSuccess$ = this.loginSuccessSubject.asObservable();

    constructor(
        public afAuth: AngularFireAuth,
        public router: Router,
        public ngZone: NgZone,
        public userService: UserService,
        public http: HttpClient,
        private pushTokenService: PushTokenService,
        private nativeTwilioVoice: NativeTwilioVoiceService
    ) {}

    /**
     * [login - Signs in to Firebase with Email + Password]
     * @param   {string} email     [Users email address]
     * @param   {string} password  [Users password]
     * @returns {Promise<any>}
     */
    login(email: string, password: string): Promise<any> {
        //console.log("user executed login");
        return this.afAuth
            .signInWithEmailAndPassword(email, password)
            .then((result) => {
                this.afAuth.authState.subscribe((user) => {
                    if (user) {
                        // Get user details from backend and save the full response
                        this.userService.getUserDetails(user.uid).subscribe((response) => {
                            // Store the full user response in localStorage
                            localStorage.setItem('user', JSON.stringify(response));
                            
                            // Set the user account in the UserService
                            this.userService.setUserAccount(response);
                            this.loginSuccessSubject.next();

                            this.pushTokenService.registerCurrentDevice().catch((error) => {
                                console.error('Failed to register push token after login:', error);
                            });
    
                            // Navigate to conversations page
                            this.router.navigate(['conversations']);
                        });
                    }
                });
            });
    }

    /**
     * [logout - Signs user out of their account]
     * @returns {Promise<any>}
     */
    logout(): Promise<any> {
        return this.nativeTwilioVoice
            .unregister()
            .catch(() => undefined)
            .then(() => this.pushTokenService.unregisterCurrentDevice())
            .catch(() => undefined)
            .then(() => this.afAuth
            .signOut()
            .then(() => {
                localStorage.removeItem('user');
                this.router.navigate(['login']);
            }));
    }

    /**
     * [isLoggedIn - Checks if user is logged in]
     * @returns {boolean}
     */
    isLoggedIn(): boolean {
        let user = JSON.parse(localStorage.getItem('user')!);
        let success = false;
    
        if(user) {
            success = true;
        }

        return success;
    }
}
